import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
  checkNotNewNotification,
  newGetNotificationNoViewed
} from '../../../utils/apiHeader';

import Icon from '../../core/Icon';
import {
  HomeStrong,
  Bell,
  CalendarStrong,
  Apps,
  ChatStrong,
  Persona
} from '../../../../assets/images';

import { getToken } from '../../../utils/apiUser';

import { StyledNavBar } from './style';

const NavBarWidget = props => {
  const { className, match, notifications, idUser } = props;
  const [arrowPosition, setArrowPosition] = useState(0);
  const [hasAccess, setHasAccess] = useState('');
  const [badgeNotifications, setBadgeNotifications] = useState(
    _.filter(notifications.content, notif => notif.viewed === false).length
  );
  let interval;

  const sendNotification = (numNotifications, newNot) => {
    if (newNot > 0) {
      const { ipcRenderer } = window.require('electron');
      ipcRenderer.sendSync('update-notifications');
      ipcRenderer.sendSync('update-badge', numNotifications);
    }
  };

  const checkNewNot = () => {
    newGetNotificationNoViewed({}).then(res => {
      const filter = _.filter(res.content, notif => notif.viewed === false);
      const newNot = _.filter(res.content, notif => notif.newNot === true);
      const numNotifications = filter.length;
      sendNotification(numNotifications, newNot.length);
      filter.forEach(notification => {
        checkNotNewNotification(notification?.idNotification);
      });
      setBadgeNotifications(numNotifications);
    });
  };

  const sendIntervalNotifications = () => {
    interval = setInterval(() => {
      checkNewNot();
    }, 40000);
  };

  const filterNotificationType = () => {
    if (notifications && notifications.length > 0) {
      const allTypeNotification = _.find(
        notifications,
        type => type.typeAppNotification === 'ALL'
      );
      if (
        allTypeNotification &&
        allTypeNotification.typeAppNotification === 'ALL' &&
        allTypeNotification.count > 0
      ) {
        sendIntervalNotifications();
      }
    }
  };

  useEffect(() => {
    filterNotificationType();
    return () => {
      clearInterval(interval);
    };
  }, [notifications]);

  useEffect(() => {
    let active = document.querySelector('.NavBarWidget-item.active');
    if (!active) {
      active = document.querySelector('body');
    }
    const newPosition = Math.round(active.getBoundingClientRect().left) + 6;
    setArrowPosition(newPosition);

    checkNewNot();

    getToken().then(data => setHasAccess(data));
    return () => {
      clearInterval(interval);
    };
  }, []);

  const moveArrow = e => {
    const newPosition = Math.round(e.target.getBoundingClientRect().left) + 6;
    setArrowPosition(newPosition);
  };

  return (
    <StyledNavBar className={className} arrowPosition={arrowPosition}>
      <ul className="NavBarWidget-list">
        <li
          className={`NavBarWidget-item ${
            match.path === '/widget/noticias' ? 'active' : ''
          }`}
        >
          <Link to="/widget/noticias" onClick={e => moveArrow(e)}>
            <Icon svg={HomeStrong} className="NavBarWidget-icon" />
          </Link>
        </li>
        <li
          className={`NavBarWidget-item ${
            match.path === '/widget/notificaciones' ? 'active' : ''
          }`}
        >
          <Link
            to="/widget/notificaciones"
            className={`NavBarWidget-noti ${
              badgeNotifications > 0 ? 'notification' : ''
            }`}
            onClick={e => moveArrow(e)}
          >
            <Icon svg={Bell} className="NavBarWidget-icon" />
          </Link>
        </li>
        <li
          className={`NavBarWidget-item ${
            match.path === '/widget/agenda' ? 'active' : ''
          }`}
        >
          <Link to="/widget/agenda" onClick={e => moveArrow(e)}>
            <Icon svg={CalendarStrong} className="NavBarWidget-icon" />
          </Link>
        </li>
        <li
          className={`NavBarWidget-item ${
            match.path === '/widget/apps' ? 'active' : ''
          }`}
        >
          <Link to="/widget/apps" onClick={e => moveArrow(e)}>
            <Icon svg={Apps} className="NavBarWidget-icon" />
          </Link>
        </li>
        {hasAccess.length > 0 && (
          <li
            className={`NavBarWidget-item ${
              match.path === '/widget/chat' ? 'active' : ''
            }`}
          >
            <Link to="/widget/chat" onClick={e => moveArrow(e)}>
              <Icon svg={ChatStrong} className="NavBarWidget-icon" />
            </Link>
          </li>
        )}
        <li
          className={`NavBarWidget-item ${
            match.path === '/widget/logout' ? 'active' : ''
          }`}
        >
          <Link
            to={`/widget/perfil/${idUser}/mi_perfil`}
            onClick={e => moveArrow(e)}
          >
            <Icon svg={Persona} className="NavBarWidget-icon" />
          </Link>
        </li>
      </ul>
    </StyledNavBar>
  );
};

const mapStateToProps = state => ({
  notifications: state.notifications.notificationsList,
  idUser: state.user.user.userId
});

export default withRouter(connect(mapStateToProps)(NavBarWidget));
